import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ReportCategoryFilterOption } from '../../types/CategorySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchReportCatFilterOptionsParams {
    propertyId: string;
}

/**
 * Fetches category options for report filter dropdown via categories-stats.
 * Returns id + title only. Uses same API contract as ReportSpendByCategory.
 */
export const fetchReportCatFilterOptions = createAsyncThunk<
    ReportCategoryFilterOption[],
    FetchReportCatFilterOptionsParams,
    ThunkConfig<string>
>('category/fetchReportCatFilterOptions', async ({ propertyId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const response = await extra.api.get<
            Array<{ id: string; title: string }>
        >(
            `/v1/reports/categories-stats?property_id=${encodeURIComponent(
                propertyId,
            )}`,
        );
        const items = Array.isArray(response.data) ? response.data : [];

        const mappedItems: ReportCategoryFilterOption[] = items.map((r) => ({
            id: r.id,
            title: r.title,
        }));

        mappedItems.sort((a, b) => a.title.localeCompare(b.title));

        return mappedItems;
    } catch {
        return rejectWithValue('error');
    }
});
